import { DatePipe, DecimalPipe } from "@angular/common";
import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ButtonComponent } from "@components/button/button.component";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { TranslateDirective } from "@ngx-translate/core";
import { PlaneraAtgardBaseComponent } from "../planera-atgard-base.component";

@Component({
    selector: "rask-planera-atgard-popup",
    templateUrl: "./planera-atgard-popup.component.html",
    styleUrls: ["./planera-atgard-popup.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgbTooltip,
        TranslateDirective,
        ButtonComponent,
        DecimalPipe,
        DatePipe
    ]
})
export class PlaneraAtgardPopupComponent extends PlaneraAtgardBaseComponent implements OnInit { }
